import { render, staticRenderFns } from "./VideoUploadFormular.vue?vue&type=template&id=0d9f3bc3&scoped=true&"
import script from "./VideoUploadFormular.vue?vue&type=script&lang=js&"
export * from "./VideoUploadFormular.vue?vue&type=script&lang=js&"
import style0 from "./VideoUploadFormular.vue?vue&type=style&index=0&id=0d9f3bc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9f3bc3",
  null
  
)

export default component.exports